import moment from 'moment';
const state = {
  currentDateTime: moment(),
  clockTickerInterval: null,
  clockUpdatesIntervalInSeconds: 1 * 60
};

const getters = {
  getClientClockDateTime(state) {
    return state.currentDateTime;
  }
};

const mutations = {
  updateCurrentTime(state) {
    state.currentDateTime = moment.utc();
  },
  updateClockTickerInterval(state, intervalRef = null) {
    state.clockTickerInterval = intervalRef;
  }
};

const actions = {
  startClientClock(context) {
    if (context.state.clockTickerInterval) {
      clearInterval(context.state.clockTickerInterval);
    }
    const intervalRef = setInterval(
      () => {
        context.commit('updateCurrentTime');
      },
      (context.state.clockUpdatesIntervalInSeconds || 1) * 1000
    );
    context.commit('updateClockTickerInterval', intervalRef);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
